import { Injectable } from '@angular/core';
import { ShowAllQuery } from './state/show-all.query';
import { ShowAllStore } from './state/show-all.store';
import { SoftwareOptionsService } from '@core/companySoftwareOptions/service/softwareOptions.service';
import { distinctUntilChanged, map, Observable, switchMap } from 'rxjs';
import { IDoctorsMap } from './state/show-all.interface';
import { SoftwareOptionsKeys } from '@shared/enums/software-options-keys.enum';
import { SoftwareOptionsForCompany } from '@shared/enums';
import { ShellContextService } from 'app/services/shell-context/shell-context.service';

@Injectable({ providedIn: 'root' })
export class ShowAllService {

    constructor(
        private readonly shellContextService: ShellContextService,
        private readonly showAllQuery: ShowAllQuery,
        private readonly showAllStore: ShowAllStore,
        private readonly softwareOptionsService: SoftwareOptionsService
    ) { }

    get isShowAllToggleEnabled$(): Observable<boolean> {
        return this.showAllQuery.isShowAllToggleEnabled$;
    }

    get hasFullOrdersVisibility$(): Observable<boolean> {
        return this.showAllQuery.hasFullOrdersVisibility$;
    }

    get doctorsMap$(): Observable<IDoctorsMap> {
        return this.showAllQuery.doctorsMap$;
    }

    updateIsShowAllToggleEnabled(isShowAllToggleEnabled: boolean): void {
        this.showAllStore.update({ isShowAllToggleEnabled });
    }

    updateDoctorsMap(doctorsMap: IDoctorsMap): void {
        this.showAllStore.update({ doctorsMap });
    }

    updateHasFullOrdersVisibility(hasFullOrdersVisibility: boolean): void {
        this.showAllStore.update({ hasFullOrdersVisibility });
    }

    resetState(): void {
        this.showAllStore.reset();
    }

    get isShowAllSwoEnabled$(): Observable<boolean> {
        return this.shellContextService.selectedCompanyId$.pipe(
            distinctUntilChanged(),
            switchMap(companyId => this.softwareOptionsService.getCompanySoftwareOptionsKeyValuePair(companyId)),
            map(softwareOptions => (this.showAllQuery.hasFullOrdersVisibility && Object.values(softwareOptions).includes(SoftwareOptionsForCompany.ShowAllDoctorsOrders)))        )
    }
}
